import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import api from "../chat/api"; // adjust if needed
import { toast } from "../../utils/appToast";

const FilterTags = ({
  selectedTags = [],
  onApply,
  onClear,
  onClose,
  anchorRef,
}) => {
  const [tags, setTags] = useState([]);
const [selected, setSelected] = useState(selectedTags.map(tag => tag.name)); // 👈 use tag names
  const [search, setSearch] = useState("");
const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFilteredTags();
  }, [search]);

  const fetchFilteredTags = async () => {
    setLoading(true);
  try {
    const params = {};

      if (search.trim()) {
      params.tags = search.trim(); // for search
    } // 🛑 Don't filter by selected.join(',') else it limits to applied only

    const response = await api.get(`/api/tagging/tags/filter/`, { params });
    setTags(response.data || []);
} catch (err) {
    const msg =
      err?.response?.data?.detail ||
      err?.message ||
      "Failed to create tag. Please try again.";

    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  
  } finally {
    setLoading(false); // Done loading
  }
};

const handleToggle = (tagName) => {
  setSelected((prev) =>
    prev.includes(tagName)
      ? prev.filter((name) => name !== tagName)
      : [...prev, tagName]
  );
};


  const handleApply = () => onApply?.(selected);

useEffect(() => {
  fetchFilteredTags();
}, [search]);

  const handleClear = () => {
  setSelected([]);
  onClear?.(); // let parent clear state & table
};


  // Abort rendering if ref isn't ready
  if (!anchorRef?.current) return null;

  // Positioning logic
  const rect = anchorRef.current.getBoundingClientRect();

  const dropdown = (
    
    <div
      className="fixed bg-white border rounded-md shadow-lg p-4 w-[280px] z-[9999]"
      style={{
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-1">
        <h2 className="text-[#3F3F46] text-[16px] font-[600] font-[Outfit]">
          Filter
        </h2>
        <button onClick={onClose}>
          <span className="text-xl font-semibold text-[#3F3F46]">×</span>
        </button>
      </div>

      <p className="text-[#52525B] text-[13px] font-[400] font-[Outfit] mb-2">
        Choose filters to refine the list
      </p>

      {/* Search */}
      <div className="relative mb-3">
        <input
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-10 pr-3 py-2 rounded-[24px] border border-[#D9D9D9] text-sm placeholder:text-[#888]"
        />
        <img
          src="/search.svg"
          alt="search"
          className="absolute top-2.5 left-3 w-5 h-5 opacity-70"
        />
      </div>

      {/* Tags List (scrollable only here) */}
    <div className="max-h-[144px] overflow-y-auto pr-1 mb-3 filter-scrollbar">
  {loading ? (
    <div className="text-center text-gray-500 text-sm font-medium py-4">
      Loading tags...
    </div>
  ) : tags.length === 0 ? (
    <div className="text-center text-gray-400 py-4 text-sm">
      No tags found.
    </div>
  ) : (
    tags.map((tag) => (
      <label
        key={tag.id}
        htmlFor={`tag-${tag.id}`}
        className="flex items-center gap-2 mb-2 cursor-pointer select-none"
      >
        {/* Checkbox */}
        <input
          type="checkbox"
          id={`tag-${tag.id}`}
          checked={selected.includes(tag.name)}
          onChange={() => handleToggle(tag.name)}
          className="appearance-none w-6 h-6 border-[1.5px] border-[#c0c0c0] rounded-[4px] cursor-pointer bg-white"
          style={{
            backgroundImage: selected.includes(tag.name)
              ? "url('/checck.svg')"
              : "none",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "20px 20px",
          }}
        />

        {/* Color dot */}
        <span
          className="inline-block w-3 h-3 rounded-full"
          style={{ backgroundColor: tag.color }}
        />

        {/* Tag name + count */}
        <span className="text-[#18101C] font-[Outfit] text-[14px] font-[500]">
          {tag.name}
          <span className="text-[#52525B] ml-1">
            {/* ({tag.document_count ?? 0}) */}
          </span>
        </span>
      </label>
    ))
  )}
</div>


      {/* Footer buttons */}
      <div className="flex justify-between items-center pt-1">
        <button
          onClick={handleClear}
          className="px-5 py-[10px] border border-[rgba(0,0,0,0.10)] rounded-[6px] text-[#52525B] font-[Outfit] text-[16px] font-[600] bg-[#FEF9F7]"
        >
          Clear All
        </button>
        <button
          onClick={handleApply}
          className="px-7 py-[10px] rounded-[6px] bg-[#C95EBE] hover:bg-[#b04aad] text-[#EAF7FF] font-[Outfit] text-[16px] font-[600]"
        >
          Apply filter
        </button>
      </div>
    </div>
  );

  return ReactDOM.createPortal(dropdown, document.body);
};

export default FilterTags;
